export function getRouteStatusColour(status: string) {
  switch (status) {
    case 'Activated':
      return 'var(--consignment-staged-colour)';
    case 'Enroute':
      return 'var(--consignment-picked-up-colour)';
    case 'Completed':
      return 'var(--consignment-in-transit-colour)';
    case 'Closed':
      return 'var(--consignment-delivered-colour)';
  }
}

export function getMapElementColour(index: number): string {
  return mapElementColours[index % mapElementColours.length];
}

export const mapElementColours = [
  '#6F9696',
  '#BD00BF',
  '#6C72A1',
  '#BF8E3A',
  '#009662',
  '#006C8E',
  '#1300BD',
  '#909C00'
];

export default { getRouteStatusColour, getMapElementColour };
